import Recompensas from "./Recompensas";

export default Recompensas;
